import * as React from "react";
import styled from "styled-components";
import { useAuth } from '../../contexts/AuthContext';
import { usePrivacy } from '../../contexts/PrivacyContext';


const UserAvatar = ({ initials, backgroundColor, fullName }) => (
    <AvatarCircle $backgroundColor={backgroundColor} data-tooltip={fullName}>{initials}</AvatarCircle>
);

const UserList = ({ contributors }) => {
    const { groupMembers } = useAuth();
    const { maskName, maskInitial } = usePrivacy();

    const getUser = (email) => {
        return groupMembers.find(member => member.email === email) || {};
    };

    return (
        <UserListWrapper>
            <AvatarStack>
                {contributors.map((userData, index) => {
                    const user = getUser(userData.email);
                    return (
                        <UserItem key={index}>
                                <UserAvatar
                                    initials={maskInitial(user.name) || user.initial}
                                    backgroundColor={user.color || '#cccccc'}
                                    fullName={maskName(user.name || user.email)}
                                />
                        </UserItem>
                    );
                })}
            </AvatarStack>
        </UserListWrapper>
    );
};

const UserListWrapper = styled.div`
    //background-color: #08e708;
    display: flex;
    margin-top: -6px;
    margin-left: 8px;
    flex-direction: column;
    gap: 2px;
`;

const UserItem = styled.div`
    display: inline-flex;
    position: relative;
`;


const AVATAR_SIZE = 22;

const AvatarCircle = styled.div`
    font-family: Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    display: inline-flex;
    align-items: center;
    line-height: 1;   
    position: relative;  
    justify-content: center;
    width: ${AVATAR_SIZE}px;
    height: ${AVATAR_SIZE}px;
    border-radius: 9999px;
    background-color: ${props => props.$backgroundColor};
    border: 1px solid #fff;   
    box-sizing: content-box;    
    color: #111827;
    font-size: 10px;                   /* balanced inside 20px circle */
    font-weight: 600;
    vertical-align: middle;            /* baseline-align with Tag */
    margin-right: 0;                   /* spacing controlled by gap above */
    transition: opacity .2s ease, visibility .2s ease, transform .15s ease, box-shadow .15s ease;

    /* zoom + bring above neighbors on hover */
   &:hover {
    transform: scale(1.12);
    z-index: 3;
   }

  /* tooltip bubble */
  &:hover::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    background: #111827;
    color: #fff;
    font: 600 12px/1.2 Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    padding: 6px 8px;
    border-radius: 6px;
    white-space: nowrap;
    box-shadow: 0 6px 18px rgba(0,0,0,.15);
    pointer-events: none;
  }

  /* tooltip arrow */
  &:hover::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #111827;
    pointer-events: none;
  }
`;

const AvatarStack = styled.div`
  display: flex;
  align-items: center;

  > * + * {
    margin-left: -8px; /* Tailwind space-2 = 0.5rem = 8px */
  }
`;

export default UserList;


